import { Validator } from "@bps/validator";

const validator = new Validator();
export const pinLengthSchema = validator.string().requiredLength(6, {
  message: "Pin code length should be 6 characters."
});
